import { API_URL_WS_FORMULAIRE, APP_URL_APPLICATION } from '@amo/core/constants/constants.js';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { POST_PAY_EMBEDDED, postPayEmbedded } from '../../../../../redux/actions/app/pay/pay.action';
import { setStep } from '../../../../../redux/actions/app/ui/ui.actions';
import { getFractionnementPoliceDemandeTarifInit, getToken } from '../../../../../redux/selectors/init/init.selectors';
import { getPayEmbeddedData } from '../../../../../redux/selectors/pay/pay.selectors';
import { getListeFormulesTarif } from '../../../../../redux/selectors/tarif/tarif.selectors';
import { getLoadingEntity } from '../../../../../redux/selectors/ui/ui.selectors';
import { getVehicule } from '../../../../../redux/selectors/vehicule/vehicule.selectors';
import { getStepBySlug } from '../../../../../utils/function';
import Paiement from './Paiement';

const mapStateToProps = (state) => {
    return {
        vehicule: getVehicule(state),
        formules: getListeFormulesTarif(state),
        fractionnementChoisi: getFractionnementPoliceDemandeTarifInit(state),
        query: `${API_URL_WS_FORMULAIRE}/pay-embedded/${getToken(state)}`,
        url_pay: {
            token: getToken(state),
            url_return: `${APP_URL_APPLICATION}`,
        },
        payLoaded: getLoadingEntity(state, POST_PAY_EMBEDDED),
        payEmbeddedData: getPayEmbeddedData(state),
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            postPayEmbedded,
            setStep,
        },
        dispatch,
    );

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { url_pay, query } = stateProps;
    const { postPayEmbedded, setStep } = dispatchProps;
    const { data } = ownProps;

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        postPaySubmit: () => postPayEmbedded({ form: data, query, url_pay }),
        goToValidation: () => setStep({ step: getStepBySlug('validation') }),
    };
};

const PaiementContainer = compose(connect(mapStateToProps, mapDispatchToProps, mergeProps))(Paiement);

export default PaiementContainer;
